var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.downloadLoading,
          expression: "downloadLoading",
        },
      ],
      staticClass: "task-status-container",
    },
    [
      _c(
        "el-card",
        { staticClass: "search-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入任务名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.taskTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "taskTitle", $$v)
                      },
                      expression: "searchForm.taskTitle",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入用户卡号", clearable: "" },
                    model: {
                      value: _vm.searchForm.cardNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "cardNo", $$v)
                      },
                      expression: "searchForm.cardNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入手机号", clearable: "" },
                    model: {
                      value: _vm.searchForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "mobile", $$v)
                      },
                      expression: "searchForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "任务状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "待完成", value: "todo" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "可领取", value: "ready" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已领取", value: "done" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "领取中", value: "loading" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    on: { change: _vm.changeTime },
                    model: {
                      value: _vm.times,
                      callback: function ($$v) {
                        _vm.times = $$v
                      },
                      expression: "times",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.fetchList },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.resetForm } }, [
                    _vm._v("重置"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.download } },
                    [_vm._v("导出")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "table-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                stripe: "",
                "element-loading-text": "加载中...",
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "60" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "taskTitle",
                  label: "任务名称",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "taskType",
                  label: "任务类型",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.taskType === "single"
                                ? "单次"
                                : scope.row.taskType === "cycle"
                                ? "循环"
                                : "-"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "cardNo", label: "用户卡号", width: "140" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: "手机号", width: "140" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "userName", label: "用户姓名", width: "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createDateTime",
                  label: "任务创建时间",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n           " +
                            _vm._s(
                              _vm.formatTimestamp(scope.row.createDateTime)
                            ) +
                            "\n         "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "任务状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            style:
                              scope.row.status === "loading"
                                ? "cursor:pointer"
                                : "",
                            attrs: {
                              type:
                                scope.row.status === "loading"
                                  ? "warning"
                                  : "info",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleStatusClick(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.statusMap[scope.row.status] || "-") +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "field1", label: "有效订单号" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "receiveTime",
                  label: "奖励领取时间",
                  width: "130",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  total: _vm.searchForm.total,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }